module.exports = __webpack_public_path__ + "img/prd_pack.d8ea09b7.png";